import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/Gallery.css';
import imgAvatar1 from '../Images/thailand1.jpg';
import imgAvatar2 from '../Images/Vietnam1.jpg';
import imgAvatar3 from '../Images/singapore.jpg';
import imgAvatar4 from '../Images/azerbaijan.jpg';
import imgAvatar5 from '../Images/cambodia.jpg';
import imgAvatar6 from '../Images/malaysia.jpg';
import imgAvatar7 from '../Images/bali1.jpg';
import imgAvatar8 from '../Images/dubai1.jpg';

const ServiceCountries = () => {


    const images = [
        { src: imgAvatar1, desc: "THAILAND" },
        { src: imgAvatar2, desc: "VIETNAM" },
        { src: imgAvatar3, desc: "SINGAPORE" },
        { src: imgAvatar4, desc: "AZERBAIJAN" },
        { src: imgAvatar5, desc: "CAMBODIA" },
        { src: imgAvatar6, desc: "MALAYSIA" },
        { src: imgAvatar7, desc: "BALI" },
        { src: imgAvatar8, desc: "DUBAI" },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = (index) => {
        setCurrentIndex(index);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    return (
        <div className='gallery_bg'>
        <div className="container py-4">
            <h1 className="text-center mb-4">Image Gallery</h1>
            <div className="gallery">
                {images.map((image, index) => (
                    <div key={index} className="gallery-item">
                        <img
                            src={image.src}
                            alt={image.desc}
                            onClick={() => showModal(index)}
                        />
                        <div className="image-caption">{image.desc}</div>
                    </div>
                ))}
            </div>

            {isModalOpen && (
  <div className={`modal__overlay ${isModalOpen ? "show" : ""}`} aria-hidden={!isModalOpen}>
  <div className="modal__content">
    <button className="modal__close-btn" onClick={closeModal}>
      ×
    </button>

    <button className="modal__nav-btn modal__nav-btn--prev" onClick={prevImage}>
      &#10094;
    </button>

    <img
      src={images[currentIndex].src}
      alt={images[currentIndex].desc}
      className="modal__image"
    />

    <button className="modal__nav-btn modal__nav-btn--next" onClick={nextImage}>
      &#10095;
    </button>
  </div>
</div>
)}


        </div>
        </div>
    );
};

export default ServiceCountries;


// import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import '../CSS/Gallery.css';
// import CustomModal from '../Pages/CustomModel';

// // Import local images
// import imgAvatar1 from '../Images/thailands.jpg';
// import imgAvatar2 from '../Images/malaysia.jpg';
// import imgAvatar3 from '../Images/singapore.jpg';
// import imgAvatar4 from '../Images/dubai.jpg';
// import imgAvatar5 from '../Images/manali.jpg';
// import imgAvatar6 from '../Images/rishikesh.jpg';

// function ServiceCountries() {
//     const [currentImageIndex, setCurrentImageIndex] = useState(null);

//     const images = [imgAvatar1, imgAvatar2, imgAvatar3, imgAvatar4, imgAvatar5,imgAvatar6];

//     const openImage = (index) => {
//         setCurrentImageIndex(index);
//     };

//     const closeModal = () => {
//         setCurrentImageIndex(null);
//     };

//     const showPrevImage = () => {
//         setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1));
//     };

//     const showNextImage = () => {
//         setCurrentImageIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0));
//     };

//     return (
//         <div className="container-fluid text-center" style={{ backgroundColor: '' }}>
//             <div className='p-5 ms-5 me-5'>
//                 <h2 className='p-4'>Gallery</h2>
//                 <div className="row">
//                     {images.map((img, index) => (
//                         <div className="col-lg-3 col-md-4 col-6 mb-4" key={index}>
//                             <img
//                                 src={img}
//                                 alt={`Gallery ${index}`}
//                                 className="img-fluid img-thumbnail"
//                                 onClick={() => openImage(index)}
//                             />
//                         </div>
//                     ))}
//                 </div>

//                 {currentImageIndex !== null && (
//                     <CustomModal
//                         show={true}
//                         onClose={closeModal}
//                         onPrev={showPrevImage}
//                         onNext={showNextImage}
//                         currentImage={images[currentImageIndex]}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// }

// export default ServiceCountries;
